var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-text',[_c('food-browser')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }